import { EnvironmentData, WorkspaceData } from '~/api';
import { shouldShowBillingBanner } from '~/pages/Billing/utils.ts';

const shouldShowInProductBanner = ({
  environment,
  workspace
}: {
  workspace: WorkspaceData;
  environment: EnvironmentData;
}) => {
  return shouldShowBillingBanner({
    environment,
    workspace
  });
};

export { shouldShowInProductBanner };
